import { Component, OnInit, Output, EventEmitter, Inject, Input, OnDestroy } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
    selector: 'shared-form-for-schedule',
    templateUrl: './form-for-schedule.shared.component.html',
    styleUrls: ['./form-for-schedule.shared.component.scss']
})
export class FormForScheduleComponent extends FormTypesComponent implements OnInit, OnDestroy {
    private _pickups: OLO.Ordering.IPickupTime[];

    @Input() public locationNo!: number;
    @Input() public periods: OLO.Ordering.IPeriod[];
    @Output() public onPickupSelected: EventEmitter<OLO.Ordering.IPickupTime> = new EventEmitter();
    public options$: Observable<OLO.Components.DropDown.IDropDownOption[]>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
    ) {
        super(config, formBuilder);
        this.formName = 'schedule';
    }

    ngOnInit(): void {
        this.formControl = this.formBuilder.group({
            period: [
                { value: '', disabled: false },
                [
                    Validators.required,
                ]
            ],
            pickupTime: [
                { value: '', disabled: false },
                [
                    Validators.required,
                ]
            ],
        });

        super.ngOnInit();

        this.formChangesListener$ = this.formControl.get('pickupTime').valueChanges
            .subscribe(value => {
                this.onPickupSelected.emit(this._pickups.find(obj => obj.Id === value));
            });

        if (this.periods && this.periods.length) {
            this.formControl.get('period').setValue(this.periods[0].Id);
        }
    }

    ngOnDestroy(): void {
        if (this.formChangesListener$ && !this.formChangesListener$.closed) this.formChangesListener$.unsubscribe();
    }

    // public get selectedPeriodObject(): OLO.Ordering.IPeriod {
    //     const value = this.formControl.get('period').value;
    //     return value ? this.periods?.find(obj => obj.Id === +value) : null;
    // }

    public get selectedPickupObject(): OLO.Ordering.IPickupTime {
        const value = this.formControl.get('pickupTime').value;

        return value ? this.pickupsList?.find(obj => obj.Id === +value) : null;
    }

    public handleFormSubmit($event: Event): void {
        this.onFormSubmit.emit({ event: $event, form: this.formControl });
    }

    public handlePeriodChange($event: OLO.Components.IPrevNextEvent): void {
        if ($event.previous !== $event.next) {
            const selectedValue = this.periods?.find(obj => obj.Id === +$event.next);

            if (selectedValue) {

                if (!this.locationNo) {
                    if (selectedValue.IsToday) {

                        this.controllers.filters.pickupTimesListForAllLocations$(false, null, false)
                            .pipe(
                                take(1)
                            )
                            .subscribe(list => {
                                this._pickups = this._calculateTimes(list);
                                this.formControl.get('pickupTime').setValue(this._pickups[0]?.Id || '');
                            });
                    } else {
                        this.controllers.filters.pickupTimesListForAllLocationsForPeriod$(selectedValue)
                            .pipe(
                                take(1)
                            )
                            .subscribe(list => {
                                this._pickups = this._calculateTimes(list);
                                this.formControl.get('pickupTime').setValue(this._pickups[0]?.Id || '');
                            });
                    }
                } else {
                    this.controllers.filters.pickupTimesListForLocation$(selectedValue, this.locationNo)
                        .pipe(
                            take(1)
                        )
                        .subscribe(list => {
                            this._pickups = this._calculateTimes(list).map(obj => {
                                if (obj.IsAsap) {
                                    return {
                                        ...obj,
                                        ShortName: 'ASAP',
                                    };
                                }

                                return obj;
                            });

                            this.formControl.get('pickupTime').setValue(this._pickups[0]?.Id || '');
                        });
                }
            }
        }
    }

    // public handlePickupTimeChange($event: OLO.Components.IPrevNextEvent): void {
    //     if ($event.previous !== $event.next) {
    //         console.log('pickupTime changed', $event);
    //     }
    // }

    public get pickupsList(): OLO.Ordering.IPickupTime[] {
        return this._pickups;
    }

    private _calculateTimes(pickupTimes: OLO.Ordering.IPickupTime[]): OLO.Ordering.IPickupTime[] {
        const pickupTimesFiltered = [...pickupTimes];

        return [...pickupTimesFiltered
            .filter(time => time.IsAsap || time.Id < 0 || (new Date(time.DateLocalISO).getTime()) > (new Date()).getTime())];
    }
}
